export default {
  API_KEY: "849dc45334e0500230421a3ed56fb799",
  VIDEO_TOKEN: "85f424413b31f0bec82ee0f6f3176b3d"
}
